// Sprite asset URLs (Vite will fingerprint in prod). Works in dev & prod.
import spaceship1Url from './spaceship_1.png?url';

// Asteroid variations with different sizes
// Asteroid type 1
import asteroid1_64Url from './asteroids/asteroid_1_64.png?url';
import asteroid1_96Url from './asteroids/asteroid_1_96.png?url';
import asteroid1_128Url from './asteroids/asteroid_1_128.png?url';
import asteroid1_256Url from './asteroids/asteroid_1_256.png?url';
import asteroid1_384Url from './asteroids/asteroid_1_384.png?url';
import asteroid1_512Url from './asteroids/asteroid_1_512.png?url';

// Asteroid type 2
import asteroid2_64Url from './asteroids/asteroid_2_64.png?url';
import asteroid2_96Url from './asteroids/asteroid_2_96.png?url';
import asteroid2_128Url from './asteroids/asteroid_2_128.png?url';
import asteroid2_256Url from './asteroids/asteroid_2_256.png?url';
import asteroid2_384Url from './asteroids/asteroid_2_384.png?url';
import asteroid2_512Url from './asteroids/asteroid_2_512.png?url';

// Asteroid type 3
import asteroid3_64Url from './asteroids/asteroid_3_64.png?url';
import asteroid3_96Url from './asteroids/asteroid_3_96.png?url';
import asteroid3_128Url from './asteroids/asteroid_3_128.png?url';
import asteroid3_256Url from './asteroids/asteroid_3_256.png?url';
import asteroid3_384Url from './asteroids/asteroid_3_384.png?url';
import asteroid3_512Url from './asteroids/asteroid_3_512.png?url';

export const SPRITE_PATHS = {
  spaceship_1: spaceship1Url,

  // Asteroid variations by type and size
  // Asteroid type 1
  asteroid_1_64: asteroid1_64Url,
  asteroid_1_96: asteroid1_96Url,
  asteroid_1_128: asteroid1_128Url,
  asteroid_1_256: asteroid1_256Url,
  asteroid_1_384: asteroid1_384Url,
  asteroid_1_512: asteroid1_512Url,

  // Asteroid type 2
  asteroid_2_64: asteroid2_64Url,
  asteroid_2_96: asteroid2_96Url,
  asteroid_2_128: asteroid2_128Url,
  asteroid_2_256: asteroid2_256Url,
  asteroid_2_384: asteroid2_384Url,
  asteroid_2_512: asteroid2_512Url,

  // Asteroid type 3
  asteroid_3_64: asteroid3_64Url,
  asteroid_3_96: asteroid3_96Url,
  asteroid_3_128: asteroid3_128Url,
  asteroid_3_256: asteroid3_256Url,
  asteroid_3_384: asteroid3_384Url,
  asteroid_3_512: asteroid3_512Url,
} as const;

export type SpriteType = keyof typeof SPRITE_PATHS;

/**
 * Get the correct URL for a sprite
 * @param spriteName - Name like "spaceship_1" or "asteroid_8" or "asteroid_12"
 * @returns Proper Vite URL that works in dev and prod
 */
export function getSpriteUrl(spriteName: string): string {
  return SPRITE_PATHS[spriteName as keyof typeof SPRITE_PATHS] || spaceship1Url;
}

/**
 * Get all sprite names for automatic registration and loading
 * @returns Array of sprite names
 */
export function getAllSprites(): string[] {
  return Object.keys(SPRITE_PATHS);
}

/**
 * Get asteroid sprite name by type and size
 * @param type - Asteroid type (1, 2, or 3)
 * @param size - Size in pixels (64, 96, 128, 256, 384, or 512)
 * @returns Sprite name like "asteroid_1_256"
 */
export function getAsteroidSpriteName(type: number, size: number): string {
  return `asteroid_${type}_${size}` as keyof typeof SPRITE_PATHS;
}

/**
 * Get random asteroid type (1, 2, or 3)
 * @returns Random asteroid type
 */
export function getRandomAsteroidType(): number {
  return Math.floor(Math.random() * 3) + 1;
}

/**
 * Get asteroid sprite URL by type and size
 * @param type - Asteroid type (1, 2, or 3)
 * @param size - Size in pixels (64, 96, 128, 256, 384, or 512)
 * @returns Sprite URL
 */
export function getAsteroidSpriteUrl(type: number, size: number): string {
  const spriteName = getAsteroidSpriteName(type, size);
  return SPRITE_PATHS[spriteName as keyof typeof SPRITE_PATHS] || SPRITE_PATHS.asteroid_1_128;
}

/**
 * Get random asteroid sprite URL for given size
 * @param size - Size in pixels (64, 96, 128, 256, 384, or 512)
 * @returns Random asteroid sprite URL
 */
export function getRandomAsteroidSpriteUrl(size: number): string {
  const type = getRandomAsteroidType();
  return getAsteroidSpriteUrl(type, size);
}
